import { useQuery } from 'data-fetching-client';
import { GET_OBJECT_TYPE_BY_ID } from 'automation-ui-references/object-type-properties/ObjectTypesQueries';
import { COMPANY_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import getPropertyAssignmentValue from 'automation-ui-action-features/actions/create-object/utils/getPropertyAssignmentValue';
import { GET_OBJECT_PROPERTIES_BY_GROUP } from 'automation-ui-references/object-type-properties/ObjectTypePropertyQueries';
import { getFlattenedProperties } from 'automation-ui-action-features/queries/utils/getFlattenedProperties';
export function useCreatedRecordTitleAssignment(metadata) {
  const {
    objectTypeId
  } = metadata;
  const {
    data: {
      objectTypeById: objectTypeDefinition = undefined
    } = {}
  } = useQuery(GET_OBJECT_TYPE_BY_ID, {
    skip: !objectTypeId,
    variables: {
      objectTypeId: objectTypeId
    }
  });
  const {
    data
  } = useQuery(GET_OBJECT_PROPERTIES_BY_GROUP, {
    skip: !objectTypeId,
    variables: {
      objectTypeId: objectTypeId
    }
  });
  const propertiesByGroup = data === null || data === void 0 ? void 0 : data.automation_propertiesByGroup;
  const allProperties = getFlattenedProperties(propertiesByGroup || []);
  const displayLabelProperties = objectTypeDefinition ? [objectTypeDefinition.getPrimaryDisplayLabelProperty(), ...objectTypeDefinition.getSecondaryDisplayLabels()] : [];
  let propertyAssignment = displayLabelProperties.map(displayLabelProperty => ({
    value: getPropertyAssignmentValue(displayLabelProperty, metadata),
    propertyDefinition: allProperties.find(property => property.name === displayLabelProperty)
  })).find(assignment => !!assignment.value);

  // company objects have two possible primary display labels
  // only one is listed
  if (!propertyAssignment && objectTypeId === COMPANY_ID) {
    propertyAssignment = {
      value: getPropertyAssignmentValue('domain', metadata),
      propertyDefinition: allProperties.find(property => property.name === 'domain')
    };
  }
  return propertyAssignment || {
    propertyDefinition: null,
    value: null
  };
}